import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-63a4eb76")

_pushScopeId("data-v-63a4eb76")
const _hoisted_1 = {
  class: "ion-text-center",
  style: {"font-family":"Lora","color":"var(--ion-color-primary)"}
}
const _hoisted_2 = { class: "ion-text-center" }
const _hoisted_3 = { class: "feature-paragraph" }
const _hoisted_4 = { class: "feature-paragraph" }
const _hoisted_5 = { class: "feature-paragraph" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { style: {"height":"3vh"} }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "ion-padding",
  src: "/assets/img/logo_grey.png",
  style: {"height":"100px"},
  alt: "wedding ring logo"
}
const _hoisted_8 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_9 = {
  key: 1,
  class: "ion-text-center"
}
const _hoisted_10 = {
  key: 2,
  class: "ion-text-center"
}
const _hoisted_11 = {
  key: 3,
  class: "ion-text-center"
}
const _hoisted_12 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_13 = {
  key: 1,
  class: "ion-text-center"
}
const _hoisted_14 = {
  key: 2,
  class: "ion-text-center"
}
const _hoisted_15 = {
  key: 3,
  class: "ion-text-center"
}
const _hoisted_16 = { class: "ion-padding" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Add Item ")
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  class: "ion-padding",
  src: "/assets/img/logo_grey.png",
  style: {"height":"80px"},
  slot: "start"
}, null, -1)
const _hoisted_19 = {
  key: 0,
  style: {"height":"80px"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_page = _resolveComponent("ion-page")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_item_option = _resolveComponent("ion-item-option")!
  const _component_ion_item_options = _resolveComponent("ion-item-options")!
  const _component_ion_item_sliding = _resolveComponent("ion-item-sliding")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_export_button = _resolveComponent("export-button")!

  return (! _ctx.store.state.premium.owned)
    ? (_openBlock(), _createBlock(_component_ion_page, { key: 0 }, {
        default: _withId(() => [
          _createVNode(_component_ion_header, null, {
            default: _withId(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_back_button)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title, null, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Go Premium')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (! _ctx.showPurchase)
            ? (_openBlock(), _createBlock(_component_ion_content, {
                key: 0,
                fullscreen: true,
                class: "bgimage"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_grid, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, { style: {"display":"flex","justify-content":"center"} }, {
                            default: _withId(() => [
                              _createVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('Ready to save hours of planning time?')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, null, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, { style: {"display":"flex","justify-content":"center"} }, {
                            default: _withId(() => [
                              _createVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('Upgrade to premium to:')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, null, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, { size: "2" }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_icon, {
                                class: "check-icon",
                                icon: _ctx.checkmark,
                                size: "large"
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, null, {
                            default: _withId(() => [
                              _createVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('Invite your partner and anyone else into the app and share wedding information with them.')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, null, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, { size: "2" }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_icon, {
                                class: "check-icon",
                                icon: _ctx.checkmark,
                                size: "large"
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, null, {
                            default: _withId(() => [
                              _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('Plan the wedding day timeline and then share with the support crew & MC and get access to a suggested timeline guide.')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, null, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, { size: "2" }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_icon, {
                                class: "check-icon",
                                icon: _ctx.checkmark,
                                size: "large"
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, null, {
                            default: _withId(() => [
                              _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('Export your wedding info effortlessly and share with suppliers. Share info such as; guest names and details with stationery provider, seating and dietary requirements with venue or caterer, timelines with the MC and venue.')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, null, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, { style: {"display":"flex","justify-content":"center"} }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.showPurchase = true;})
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("Yes I want it!")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_ion_content, {
                key: 1,
                fullscreen: true
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_grid, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, { style: {"display":"flex","justify-content":"center"} }, {
                            default: _withId(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, null, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, { style: {"display":"flex","justify-content":"center"} }, {
                            default: _withId(() => [
                              (_ctx.store.state.premium.state == 'valid')
                                ? (_openBlock(), _createBlock("img", _hoisted_7))
                                : (_openBlock(), _createBlock(_component_ion_spinner, { key: 1 }))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, null, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, { style: {"display":"flex","justify-content":"center"} }, {
                            default: _withId(() => [
                              (_ctx.purchaseCancelled)
                                ? (_openBlock(), _createBlock("h2", _hoisted_8, [
                                    _createVNode(_component_ion_text, { color: "danger" }, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('Purchase Cancelled!')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : (_ctx.store.state.premium.state == 'initiated')
                                  ? (_openBlock(), _createBlock("h2", _hoisted_9, _toDisplayString(_ctx.$t("Purchasing...")), 1))
                                  : (_ctx.store.state.premium.state == 'valid')
                                    ? (_openBlock(), _createBlock("h2", _hoisted_10, _toDisplayString(_ctx.store.state.premium.title), 1))
                                    : (_openBlock(), _createBlock("h2", _hoisted_11, _toDisplayString(_ctx.$t('Please wait...')), 1))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, null, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, { style: {"display":"flex","justify-content":"center"} }, {
                            default: _withId(() => [
                              (_ctx.purchaseCancelled)
                                ? (_openBlock(), _createBlock("p", _hoisted_12, _toDisplayString(_ctx.$t("Your purchase was cancelled by the App provider.  This could be due to a credit card problem, a network error, or you simply cancelled the purchase yourself.")), 1))
                                : (_ctx.store.state.premium.state == 'initiated')
                                  ? (_openBlock(), _createBlock("p", _hoisted_13, _toDisplayString(_ctx.$t("Please wait whilst we complete your purchase.")), 1))
                                  : (_ctx.store.state.premium.state == 'valid')
                                    ? (_openBlock(), _createBlock("p", _hoisted_14, _toDisplayString(_ctx.store.state.premium.description), 1))
                                    : (_openBlock(), _createBlock("p", _hoisted_15, _toDisplayString(_ctx.$t("Loading details of the premium version.")), 1))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_ctx.store.state.premium.state == 'valid')
                        ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_col, { style: {"display":"flex","justify-content":"center"} }, {
                                default: _withId(() => [
                                  _createVNode("h2", _hoisted_16, _toDisplayString(_ctx.store.state.premium.price) + " (" + _toDisplayString(_ctx.store.state.premium.currency) + ")", 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_row, null, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, { style: {"display":"flex","justify-content":"center"} }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onBuyNow())),
                                disabled: !_ctx.store.state.premium.canPurchase
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("Buy Now")), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, null, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, { style: {"display":"flex","justify-content":"center"} }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onRestorePurchase())),
                                disabled: _ctx.store.state.premium.state == 'initiated'
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("Restore Existing Purchase")), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, null, {
                        default: _withId(() => [
                          _createVNode(_component_ion_col, { style: {"display":"flex","justify-content":"center"} }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.showPurchase = false;}),
                                color: "secondary"
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("Go Back")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_ion_page, { key: 1 }, {
        default: _withId(() => [
          _createVNode(_component_ion_header, { translucent: true }, {
            default: _withId(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_button, { onClick: _ctx.onAddItemClicked }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: _ctx.addCircleOutline
                          }, null, 8, ["icon"]),
                          _hoisted_17
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title, null, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('The Big Day')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_header, null, {
            default: _withId(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withId(() => [
                  _hoisted_18,
                  _createVNode(_component_ion_label, null, {
                    default: _withId(() => [
                      _createVNode("h1", null, _toDisplayString(_ctx.weddingDateString), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_label, null, {
                    default: _withId(() => [
                      _createVNode("h1", null, _toDisplayString(_ctx.formatTime(_ctx.store.getters.wedding.date)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { fullscreen: true }, {
            default: _withId(() => [
              (_ctx.store.state.schedule.length > 0)
                ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_item_divider, { color: "primary" }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("Day Prior to Wedding Day")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.store.state.schedule, (item, itemIdx) => {
                        return (_openBlock(), _createBlock(_Fragment, {
                          key: item.id
                        }, [
                          (_ctx.inDays(item.time) == 0 && (itemIdx == 0 || _ctx.inDays(_ctx.store.state.schedule[itemIdx - 1].time) < 0 ) )
                            ? (_openBlock(), _createBlock(_component_ion_item_divider, {
                                key: 0,
                                color: "primary"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("Wedding Day")), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ion_item_sliding, null, {
                            default: _withId(() => [
                              _createVNode(_component_ion_item, {
                                button: "",
                                onClick: ($event: any) => (_ctx.onListItemClicked(itemIdx)),
                                detail: "false",
                                lines: "full"
                              }, {
                                default: _withId(() => [
                                  (!item.hide_time)
                                    ? (_openBlock(), _createBlock(_component_ion_note, {
                                        key: 0,
                                        slot: "start"
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(_ctx.formatTime(item.time)), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(item.agenda), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_icon, {
                                    slot: "end",
                                    icon: _ctx.chevronBack
                                  }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_ion_item_options, { side: "end" }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_item_option, {
                                    color: "primary-contrast",
                                    onClick: ($event: any) => (_ctx.onDeleteClicked(item.id))
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_ion_icon, {
                                        icon: _ctx.trashOutline,
                                        color: "danger",
                                        style: {"font-size":"30px"}
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ], 64))
                      }), 128)),
                      _createVNode(_component_ion_item, null, {
                        default: _withId(() => [
                          (_ctx.store.state.premium.owned)
                            ? (_openBlock(), _createBlock("div", _hoisted_19))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.store.state.premium.owned)
            ? (_openBlock(), _createBlock(_component_export_button, {
                key: 0,
                endPoint: _ctx.apiEndpoints.exportSchedule,
                shareTitle: "My Big Day Schedule",
                shareText: "Attached is your wedding day schedule.  We suggest you email to yourself if you don't have Google Sheets or Microsoft Excel."
              }, null, 8, ["endPoint"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
})